import { render, staticRenderFns } from "./MaterialDbmSkuList.vue?vue&type=template&id=7c572308&"
import script from "./MaterialDbmSkuList.vue?vue&type=script&lang=js&"
export * from "./MaterialDbmSkuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports